<!-- eslint-disable -->
<template lang="pug">
    .olympiad-register(v-if="!areSchoolsBlocked")
        cs-loader(v-if="isLoading")
        .olympiad-register__block(v-else)
            olympiad-box
                template(slot="top")
                    olympiad-preview(:olympiad="olympiad")
                .olympiad-register__box-bottom(slot="bottom")
                    .olympiad-register__bottom-block.olympiad-register__not-available-olympiad(v-if="!filteredLevels.length") {{ $i18n.t('olympiads.olympiads_registerPage_notAvailableToYou') }}
                    div(v-else)
                        .olympiad-register__bottom-block
                            .olympiad-register__block
                                .olympiad-register__block-title {{ $i18n.t('olympiads.olympiads_registerPage_chooseATopic') }}
                                .olympiad-register__levels-block
                                    .olympiad-register__level(
                                        v-for="level in filteredLevels",
                                        :class="{'olympiad-register__level-content--checked': checkedLevel === level}"
                                    )
                                        .olympiad-register__level-content(
                                            @click="checkedLevel = level",
                                        )
                                            cs-checkbox.olympiad-register__level-checked(:checked="checkedLevel === level")
                                                | {{ level.theme }} &nbsp;
                                                |
                                                span
                                                    | {{ `(${level.startTime}-${level.endTime})` }}
                            template(v-if="+olympiad.price")
                                .olympiad-register__block
                                    .olympiad-register__block-title {{ $i18n.t('olympiads.olympiads_registerPage_toRegister') }}
                                    .olympiad-register__info-block
                                        .olympiad-register__info-line
                                            .olympiad-register__price-box
                                                .olympiad-register__price-icon
                                                    svg-icon(name="exclamation-circle", style="color: orange", size="large")
                                                span.olympiad-register__price-text
                                                    span {{ $i18n.t('olympiads.olympiads_registerPage_needToPay', {price: olympiad.price}) }}
                                .olympiad-register__info-line
                                    .olympiad-register__price-box
                                        .olympiad-register__price-icon
                                            svg-icon(name="exclamation-circle", style="color: orange", size="large")
                                        span.olympiad-register__price-text
                                            span
                                                | {{ $i18n.t('olympiads.olympiads_registerPage_alreadyPaid') }}
                            .olympiad-register__info-line
                                cs-checkbox(v-model="dataProcessing")
                                .olympiad-register__info-text
                                    | {{ $i18n.t('olympiads.olympiads_registerPage_personalDataProcessAgree') }} &nbsp;
                                    a(:href="olympiad.termsOfUseLink" target="_blank") {{ $i18n.t('olympiads.olympiads_registerPage_personalData') }}
                                    | {{ $i18n.t('olympiads.olympiads_registerPage_personalDataFamiliarized') }} &nbsp;
                                    a(:href="olympiad.rulesLink" target="_blank") {{ $i18n.t('olympiads.olympiads_registerPage_olympiadRules') }}
                        .olympiad-register__buttons-container
                            cs-button.olympiad-register__button(
                                :disabled="!dataProcessing || !checkedLevel",
                                @click="pay"
                            )
                                | {{ +olympiad.price ? $i18n.t('olympiads.olympiads_registerPage_goToThePayment') : $i18n.t('olympiads.olympiads_registerPage_toRegister') }}
    .block-message(v-else) {{ $i18n.t('errors.page_not_access') }}
</template>

<script>
    /*eslint-disable*/
    import OlympiadBox from './Box.vue'
    import OlympiadPreview from './Preview.vue'
    import OlympiadApi from '../../api/olympiad'
    import {mapState} from 'vuex'

    import BillingBlockMixin from '../../utils/user/BillingBlockMixin';
    import modulBankPaymentMixin from "../../utils/modulBankPaymentMixin";

    export default {
        mixins: [BillingBlockMixin, modulBankPaymentMixin],
        props: {
            id: [Number, String]
        },
        data() {
            return {
                isLoading: true,
                olympiad: null,
                url: null,
                checkedLevel: null,
                dataProcessing: false,
            }
        },
        computed: {
            ...mapState({
                user: state => state.auth.user
            }),
            filteredLevels() {
                return this.olympiad.levels.filter((level) => {
                    let coursesIds = level.courses.map(school => school.id);
                    let schoolsIds = level.schools.map(school => school.id);
                    let gradesIds = level.grades.map(grade => grade.id);
                    let studentsIds = level.students.map(student => student.id);
                    return this.user.type === 'olympiads-student'
                        || !level.participantsFilterType
                        || (this.user.grades.some(grade => coursesIds.includes(grade.course.id)) && !schoolsIds.length)
                        || (
                            this.user.schools.some(school => schoolsIds.includes(school.id)) &&
                            this.user.grades.some(grade => coursesIds.includes(grade.course.id)) &&
                            !gradesIds.length
                        )
                        || (this.user.grades.some(grade => gradesIds.includes(grade.id)) && !studentsIds.length)
                        || studentsIds.includes(this.user.id);
                });
            }
        },
        mounted() {
            if (this.user.type !== 'student' && this.user.type !== 'olympiads-student') {
                this.$router.push({name: 'olympiads:show', params: {id: this.id}})
            }
            this.fetchData();
        },
        methods: {
            fetchData() {
                this.isLoading = true;
                return OlympiadApi.show(this.id)
                    .then((data) => {
                        this.olympiad = data;
                        this.olympiad.levels.forEach(level => {
                            level.endTime = level.endTime || level.stages[level.stages.length - 1].endTime;
                        });
                        this.checkPageAvailability();
                        this.isLoading = false;
                    })
                    .catch(err => {
                        if (err && err.status === 403) {
                            this.$toasted.error(this.$root.$t('errors.olympiad_no_access'));
                            this.$router.push({name: 'olympiads:index'})
                        } else {
                            this.$toasted.error(this.$root.$t('errors.getting_olympiadList'));
                            this.isLoading = false;
                        }
                    });
            },
            checkPageAvailability() {
                if (!this.olympiad.isRegistrationAllowed) {
                    this.$toasted.error(this.$root.$t('errors.register_olympiad_no_access'))
                    this.$router.push({name: 'olympiads:index'})
                }
                let isUserRegistered = false;
                this.olympiad.levels.forEach(level => {
                    if (level.authRegisteredUser[0]) {
                        isUserRegistered = true;
                    }
                });
                if (isUserRegistered) {
                    this.$router.push({name: 'olympiads:show', params: {id: this.id}});
                }
            },
            pay() {
                this.isLoading = true;
                return OlympiadApi.pay(this.checkedLevel)
                    .then((data) => {
                        if (data.status) {
                            this.$toasted.success(this.$i18n.t('olympiads.olympiads_registerPage_registeredSuccess'))
                            this.$router.push({name: 'olympiads:show', params: {id: this.id}})
                        } else {
                            if (data.url.includes('https://pay.modulbank.ru/pay')) {
                                this.redirectToModulBank(data.url);
                            } else {
                                document.location = data.url;
                            }
                        }
                    })
                    .catch(err => {
                        if (err.data && +err.data.code !== 23000) {
                            this.$toasted.error(err.data.message);
                        }
                        if (+err.data.code === 23000) {
                            this.$toasted.error(this.$i18n.t('errors.integrity_constraint_violation'))
                        }
                        this.isLoading = false;
                    })
            }
        },
        components: {
            OlympiadBox,
            OlympiadPreview
        }
    }
</script>

<style lang="scss" scoped>
    .olympiad-register {
        margin: 0 auto;
        @include media($lg) {
            width: 70%;
        }
    }

    .olympiad-register__not-available-olympiad {
        text-align: center;
        color: $hsl-color-gray-51;
        font-size: 18px;
    }

    .olympiad-register__block-title {
        text-align: center;
        font-size: 18px;
        font-weight: 500;
        margin-bottom: 20px;
    }

    .olympiad-register__levels-block {
        display: flex;
        margin-bottom: 20px;
        flex-wrap: wrap;
    }

    .olympiad-register__level {
        padding: 20px 15px;
        background-color: $x-color-white;
        border: 1px solid $hsl-color-gray-88;
        border-radius: 8px;
        width: 100%;
        height: auto;
        margin-bottom: 10px;
        @include media($lg) {
            width: calc(50% - 10px);
            margin: 0 10px 10px 0;
        }
    }

    .olympiad-register__level-content .cs-checkbox {
        margin-bottom: 0;
    }

    .olympiad-register__level-content--checked {
        border: 1px solid #2187FF;
    }

    .olympiad-register__info-line {
        display: flex;
        margin-bottom: 30px;
        .cs-checkbox {
            margin-bottom: 0;
            @include media($md) {
                margin-right: 10px;
            }
        }
    }

    .olympiad-register__info-text {
        flex-wrap: wrap;
        width: 100% ;
        font-size: 14px ;
        line-height: 25px ;
        @include media($md) {
            font-size: 16px;
        }
    }

    .olympiad-register__buttons-container {
        display: flex;
        justify-content: center;
    }

    .block-message {
        text-align: center;
        font-size: 2em;
        font-family: 'Appetite';
        color: $hsl-color-gray-88;
    }
</style>
